import { MutationTree } from 'vuex';
import { LoginState } from './types';

// actionによって変更されるフィールド
export const mutations: MutationTree< LoginState> = {
    onAuthStateChanged: (state, isAuth) => {
        state.isAuth = isAuth;
    },
    onUserStateChanged: (state, status) => {
        status.status = status;
    },
};

